/**
 * 美国地址格式：门牌号, 街道, 城市, 州, 邮编, 国家
 */
export function formatUsAddress(houseNumber, street, city, state, zip, country) {
  const parts = []
  if (houseNumber && street) {
    parts.push(`${houseNumber} ${street}`)
  } else if (street) {
    parts.push(street)
  } else if (houseNumber) {
    parts.push(houseNumber)
  }
  if (city) parts.push(city)
  if (state) parts.push(state)
  if (zip) parts.push(zip)
  if (country) parts.push(country)
  return parts.join(', ')
}
